module.exports = __webpack_public_path__ + "vPcynSL0qHq_6dX7lKVByXYhjbSpvc47ee6xR_80Hnw.7a7b77b774f5049025a2.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/vPcynSL0qHq_6dX7lKVByXYhjbSpvc47ee6xR_80Hnw.woff2
// module id = ../../../../../src/assets/fonts/font-google/vPcynSL0qHq_6dX7lKVByXYhjbSpvc47ee6xR_80Hnw.woff2
// module chunks = 40